module.exports = __webpack_public_path__ + "img/g-savings.a3d89669.jpg";